/**
 * Settings page — integrations, theme, API keys, team.
 * Sprint B2: Renders existing integration pages inline via tabs.
 */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const TABS = [
  { id: "general",      label: "General" },
  { id: "integrations", label: "Integrations" },
  { id: "api-keys",     label: "API Keys" },
];

export default function SettingsPage() {
  const [tab, setTab] = useState("general");
  const navigate = useNavigate();

  return (
    <div style={{ display: "flex", height: "100%", fontFamily: "var(--font-sans)" }}>
      {/* Sidebar */}
      <div style={{ width: 200, flexShrink: 0, borderRight: "1px solid var(--border-default)", padding: "24px 12px" }}>
        <h2 style={{ fontSize: 13, fontWeight: 700, color: "var(--text-tertiary)", letterSpacing: "0.07em", textTransform: "uppercase", margin: "0 8px 12px", fontFamily: "var(--font-sans)" }}>
          Settings
        </h2>
        {TABS.map(t => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            style={{
              display: "flex", alignItems: "center", width: "100%",
              padding: "7px 10px", borderRadius: "var(--radius-sm)",
              fontSize: 13.5, fontFamily: "var(--font-sans)",
              color: tab === t.id ? "var(--blue)" : "var(--text-secondary)",
              background: tab === t.id ? "var(--blue-subtle)" : "transparent",
              fontWeight: tab === t.id ? 500 : 400,
              cursor: "pointer", transition: "all 120ms ease",
              border: "none",
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* Content */}
      <div style={{ flex: 1, overflowY: "auto", padding: 32 }}>
        {tab === "general" && (
          <div>
            <h3 style={{ fontSize: 18, fontWeight: 600, color: "var(--text-primary)", marginBottom: 24 }}>General</h3>
            <div style={{ maxWidth: 480 }}>
              {[
                ["Timezone", "Asia/Kolkata"],
                ["Language", "English"],
              ].map(([label, value]) => (
                <div key={label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 0", borderBottom: "1px solid var(--border-subtle)" }}>
                  <span style={{ fontSize: 13.5, color: "var(--text-secondary)" }}>{label}</span>
                  <span style={{ fontSize: 13.5, color: "var(--text-primary)", fontWeight: 500 }}>{value}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {tab === "integrations" && (
          <div>
            <h3 style={{ fontSize: 18, fontWeight: 600, color: "var(--text-primary)", marginBottom: 8 }}>Integrations</h3>
            <p style={{ fontSize: 13, color: "var(--text-secondary)", marginBottom: 24 }}>Connect your ad platforms, CRM, and e-commerce tools.</p>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {[
                { label: "Media Channels", desc: "Facebook, Google Ads, Universal Ads", path: "/facebook/integrations" },
                { label: "CRM Channels", desc: "HubSpot, Salesforce, Pipedrive", path: "/crm/integrations" },
                { label: "E-commerce", desc: "Shopify, WooCommerce, Etsy", path: "/e-commerce/integrations" },
              ].map(item => (
                <div
                  key={item.label}
                  onClick={() => navigate(item.path)}
                  style={{
                    display: "flex", justifyContent: "space-between", alignItems: "center",
                    padding: "14px 16px",
                    background: "var(--bg-surface)", border: "1px solid var(--border-subtle)",
                    borderRadius: "var(--radius)", cursor: "pointer",
                    transition: "border-color 150ms ease",
                  }}
                  onMouseEnter={e => (e.currentTarget.style.borderColor = "var(--border-default)")}
                  onMouseLeave={e => (e.currentTarget.style.borderColor = "var(--border-subtle)")}
                >
                  <div>
                    <div style={{ fontSize: 13.5, color: "var(--text-primary)", fontWeight: 500 }}>{item.label}</div>
                    <div style={{ fontSize: 12, color: "var(--text-tertiary)", marginTop: 2 }}>{item.desc}</div>
                  </div>
                  <span style={{ color: "var(--text-tertiary)", fontSize: 16 }}>›</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {tab === "api-keys" && (
          <div>
            <h3 style={{ fontSize: 18, fontWeight: 600, color: "var(--text-primary)", marginBottom: 8 }}>API Keys</h3>
            <p style={{ fontSize: 13, color: "var(--text-secondary)", marginBottom: 24 }}>
              Create API keys for MCP clients (Claude Desktop, external automations).
            </p>
            <div style={{ padding: "20px 16px", background: "var(--bg-surface)", border: "1px solid var(--border-subtle)", borderRadius: "var(--radius)", color: "var(--text-secondary)", fontSize: 13 }}>
              API key management coming soon.
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
